/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_TrackInputs */



/**
* | output |
* | --- |
* | "Assign To Track" |
*
* @param {Context_Menu_Event_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_track = /** @type {((inputs?: Context_Menu_Event_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer au suivi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dem Track zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna al tracciamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить для отслеживания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar a la pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配至轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックに割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक को असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir à trilha")
	return /** @type {LocalizedString} */ ("Assign To Track")
});